import {Component, Input, OnInit} from '@angular/core';

class IDocume {
}

@Component({
  selector: 'nv-render',
  templateUrl: './nv-render.component.html',
  styles: []
})
export class NvRenderComponent implements OnInit {

  @Input() document:IDocume;
  @Input() propertyName:string;

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-render/nv-render.component.ts